import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";
import { useState } from "react";

const dataFormatter = new Jsona();

const quizSubmissionApiService = async () =>
  new JsonApiService("quiz_submissions", {
    baseUrl: `${visionURL}/learning_center/api`,
    credentials: "include"
  });

export const useQuizSubmission = () => {
  const [quizScore, setQuizScore] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  return {
    createQuizSubmission: async requestData => {
      setIsSubmitting(true);
      const service = await quizSubmissionApiService();
      const response = await service
        .create(JSON.stringify(requestData))
        .then(response => response.json());
      if (response.errors) {
        setIsSubmitting(false);
        throw response.errors;
      } else {
        const submissionData = dataFormatter.deserialize(response);
        setQuizScore(submissionData.score);
        setIsSubmitting(false);
        return submissionData;
      }
    },
    quizScore,
    isSubmitting
  };
};
